





































































































































































import { Component, Vue } from 'vue-property-decorator';
import gtServices from '@/store/modules/gt_services';

// Definiera typerna här istället för att importera dem
interface ContentElement {
  type: string;
  value: string;
}

interface Category {
  id: string;
  name: string;
  image: string;
  categories?: Category[];
  items?: Category[];
  content?: ContentElement[];
}

@Component({
  name: 'ServiceTree',
})
export default class ServiceTree extends Vue {
  categoryPath: Category[] = [];
  selectedItem: Category | null = null;

  get taxData() {
    return gtServices.getDataByType('tax');
  }

  get currentLevelName(): string {
    if (this.selectedItem) {
      return this.selectedItem.name;
    }

    if (this.categoryPath.length > 0) {
      return this.categoryPath[this.categoryPath.length - 1].name;
    }

    return this.taxData ? this.taxData.name : '';
  }

  get currentCategories(): Category[] {
    if (this.categoryPath.length === 0) {
      if (this.taxData && this.taxData.categories) {
        return this.taxData.categories;
      }
      return [];
    }

    const currentCategory = this.categoryPath[this.categoryPath.length - 1];
    if (currentCategory && currentCategory.categories) {
      return currentCategory.categories;
    }
    return [];
  }

  get currentItems(): Category[] {
    if (this.categoryPath.length === 0) {
      return [];
    }

    const currentCategory = this.categoryPath[this.categoryPath.length - 1];
    if (currentCategory && currentCategory.items) {
      return currentCategory.items;
    }
    return [];
  }

  get currentContent(): ContentElement[] {
    if (this.categoryPath.length === 0) {
      return [];
    }

    const currentCategory = this.categoryPath[this.categoryPath.length - 1];
    if (currentCategory && currentCategory.content) {
      return currentCategory.content;
    }
    return [];
  }

  selectCategory(category: Category) {
    this.categoryPath.push(category);
    this.selectedItem = null;
  }

  selectItem(item: Category) {
    this.selectedItem = item;
  }

  clearSelectedItem() {
    this.selectedItem = null;
  }

  goBack() {
    if (this.selectedItem) {
      this.selectedItem = null;
    } else {
      this.categoryPath.pop();
    }
  }

  goToRoot() {
    this.categoryPath = [];
    this.selectedItem = null;
  }

  goToLevel(index: number) {
    this.categoryPath = this.categoryPath.slice(0, index + 1);
    this.selectedItem = null;
  }
}
